export class Vehicle {
    public id?: number;
    public model?: string;
    public manufacturer?: string;
    public car_registration?: string;
    public number_passengers?: number;
    public transport_type?: string;
    public user_grouper_id?: number;
    public created_at?: Date;
    public updated_at?: Date;
    public deleted_at?: Date;
}